import * as React from "react";
import { WizardHero } from "./views/WizardHero";
import { DestinationHeroGallery } from "./views/DestinationHeroGallery";
import { WizardHeroWithHeadings } from "./views/WizardHeroWithHeadings";
import { DestinationHeroProps } from "./typings";
import { withStores } from "stores";
import { observer } from "mobx-react";
import { DestinationHeroFlexModuleResult } from "typings/microserviceModels/destination-hero-flex-module";

export enum ModelView {
  Wizard = "wizard",
  Gallery = "gallery",
  WithHeadings = "withHeadings",
}

export const DestinationHero = withStores(
  "flexModuleModelStore",
  "context"
)(
  observer((props: DestinationHeroProps) => {
    const { templateComponent, flexModuleModelStore, context } = props;

    if (!templateComponent) {
      return null;
    }

    const model = flexModuleModelStore.getModel(templateComponent.metadata.id) as DestinationHeroFlexModuleResult;
    const content = model?.content;

    if (!model || model.empty || !content) {
      return null;
    }

    switch (model.view) {
      case ModelView.Gallery: {
        return <DestinationHeroGallery templateComponent={templateComponent} model={model} context={context} />;
      }
      case ModelView.WithHeadings: {
        return <WizardHeroWithHeadings templateComponent={templateComponent} model={model} context={context} />;
      }
      default: {
        return <WizardHero templateComponent={templateComponent} model={model} context={context} />;
      }
    }
  })
);

export default DestinationHero;
